/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由懒加载
const Login = () =>
    import ('@/views/Login')
const CoLibLogin = () =>
    import ('@/views/CoLibLogin')
const UserLogin = () =>
    import ('@/views/UserLogin')
const Register = () =>
    import ('@/views/Register')
const Layout = () =>
    import ('@/layout/index')
const Home = () =>
    import ('@/views/home/index')
const Purchase = () =>
    import ('@/views/purchase/index')
const PurchaseDetail = () =>
    import ('@/views/purchase/PurchaseDetail')
const resetPassword = () =>
    import ('@/views/forgetPassword/resetPassword')
const retrievePassword = () =>
    import ('@/views/forgetPassword/retrievePassword')
const Indent = () =>
    import ('@/views/indent/index')
const IndentDetail = () =>
    import ('@/views/indent/IndentDetail')
const Stock = () =>
    import ('@/views/indent/Stock')
const StockDetail = () =>
    import ('@/views/indent/StockDetail')
const Settlement = () =>
    import ('@/views/indent/Settlement')
const Requirement = () =>
    import ('@/views/requirement/index')
const Recommend = () =>
    import ('@/views/recommend/index')
const Account = () =>
    import ('@/views/account/index')
const AccountSecurity = () =>
    import ('@/views/account/AccountSecurity')
const ChangePassword = () =>
    import ('@/views/account/ChangePassword')
const ChangePhone = () =>
    import ('@/views/account/ChangePhone')
const ChangeEmail = () =>
    import ('@/views/account/ChangeEmail')
const BindEmail = () =>
    import ('@/views/account/BindEmail')

const routes = [{
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/co_lib-login',
        name: 'CoLibLogin',
        component: CoLibLogin
    },
    {
        path: '/user-login',
        name: 'UserLogin',
        component: UserLogin
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/forgetPassword/resetPassword',
        name: 'resetPassword',
        component: resetPassword
    },
    {
        path: '/forgetPassword/retrievePassword',
        name: 'retrievePassword',
        component: retrievePassword
    },
    {
        path: '/account/change-phone',
        name: 'ChangePhone',
        meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: ChangePhone
    },
    {
        path: '/account/change-email',
        name: 'ChangeEmail',
        meta: {
            requireAuth: true
        },
        component: ChangeEmail
    },
    {
        path: '/account/bind-email',
        name: 'BindEmail',
        meta: {
            requireAuth: true
        },
        component: BindEmail
    },
    {
        path: '/',
        name: 'Layout',
        redirect: '/home',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [{
                path: '/home',
                name: 'Home',
                meta: {
                    requireAuth: true
                },
                component: Home
            },
            {
                path: '/purchase',
                name: 'Purchase',
                meta: {
                    requireAuth: true
                },
                component: Purchase
            },
            {
                path: '/purchase-detail',
                name: 'PurchaseDetail',
                meta: {
                    requireAuth: true
                },
                component: PurchaseDetail
            },
            {
                path: '/indent',
                name: 'Indent',
                meta: {
                    requireAuth: true
                },
                component: Indent
            },
            {
                path: '/indent/indent-detail',
                name: 'IndentDetail',
                meta: {
                    requireAuth: true
                },
                component: IndentDetail
            },
            {
                path: '/indent/stock',
                name: 'Stock',
                meta: {
                    requireAuth: true
                },
                component: Stock
            },
            {
                path: '/indent/stock-detail',
                name: 'StockDetail',
                meta: {
                    requireAuth: true
                },
                component: StockDetail
            },
            {
                path: '/indent/settlement',
                name: 'Settlement',
                meta: {
                    requireAuth: true
                },
                component: Settlement
            },
            {
                path: '/requirement',
                name: 'Requirement',
                meta: {
                    requireAuth: true
                },
                component: Requirement
            },
            {
                path: '/recommend',
                name: 'Recommend',
                meta: {
                    requireAuth: true
                },
                component: Recommend
            },
            {
                path: '/account',
                name: 'Account',
                meta: {
                    requireAuth: true
                },
                component: Account
            },
            {
                path: '/account/security',
                name: 'AccountSecurity',
                meta: {
                    requireAuth: true
                },
                component: AccountSecurity
            },
            {
                path: '/account/change-password',
                name: 'ChangePassword',
                meta: {
                    requireAuth: true
                },
                component: ChangePassword
            }
        ]
    },
    {
        path: '*',
        component: Layout
    }
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router